import React from 'react';
import "./Footer.css"

function Footer () {
    return (
        <div id="Footer">
            <div className="container">
                <div className="copyright">
                    <p> Copyright <span>©</span> TatuMotions.All rights reserved.</p>
                </div>
            </div>   
        </div>
    );
}

export default Footer;
